import { render } from "./A-Z.vue?vue&type=template&id=6b64fab6"
import script from "./A-Z.vue?vue&type=script&lang=js"
export * from "./A-Z.vue?vue&type=script&lang=js"

import exportComponent from "/codebuild/output/src3853179034/src/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__